module.exports = __webpack_public_path__ + "img/pic11.d704774d.png";